import { useState, useEffect } from 'react';

// Sincroniza el estado de consentimiento con Google Consent Mode (gtag).
// analytics → analytics_storage; marketing → ad_storage, ad_user_data, ad_personalization.
const syncGtagConsent = (consentPrefs) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  const analyticsGranted = consentPrefs?.analytics === true;
  const marketingGranted = consentPrefs?.marketing === true;

  window.gtag('consent', 'update', {
    'analytics_storage': analyticsGranted ? 'granted' : 'denied',
    'ad_storage': marketingGranted ? 'granted' : 'denied',
    'ad_user_data': marketingGranted ? 'granted' : 'denied',
    'ad_personalization': marketingGranted ? 'granted' : 'denied'
  });
};

export const useCookieConsent = () => {
  const [consent, setConsent] = useState(null);
  const [hasConsent, setHasConsent] = useState(true); // Empezar como true para no renderizar banner durante hydration
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem('cookie-consent');
    if (savedConsent) {
      try {
        const parsed = JSON.parse(savedConsent);
        setConsent(parsed);
        setHasConsent(true);

        // Aplicar el consentimiento guardado a Google Consent Mode
        syncGtagConsent(parsed);

        // Aplicar preferencias de cookies
        if (parsed.analytics) {
          loadGoogleAnalytics();
        }
        
        if (parsed.marketing) {
          loadMarketingCookies();
        }
      } catch (error) {
        console.error('Error parsing cookie consent:', error);
        setHasConsent(false);
      }
    } else {
      setHasConsent(false);
    }
    setMounted(true);
  }, []);

  const loadGoogleAnalytics = () => {
    if (typeof window !== 'undefined' && !window.gtag) {
      // Cargar Google Analytics solo si el usuario ha dado consentimiento
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID';
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'GA_MEASUREMENT_ID');
    }
  };

  const loadMarketingCookies = () => {
    // Scripts de marketing/publicidad (actualmente sin uso)
  };

  const updateConsent = (newConsent) => {
    const consentData = {
      ...newConsent,
      timestamp: new Date().toISOString()
    };
    
    localStorage.setItem('cookie-consent', JSON.stringify(consentData));
    setConsent(consentData);
    setHasConsent(true);

    // Sincronizar con Google Consent Mode (granted/denied según categorías)
    syncGtagConsent(consentData);

    // Aplicar nuevas preferencias
    if (consentData.analytics && !consent?.analytics) {
      loadGoogleAnalytics();
    }
    
    if (consentData.marketing && !consent?.marketing) {
      loadMarketingCookies();
    }
  };

  const revokeConsent = () => {
    localStorage.removeItem('cookie-consent');
    setConsent(null);
    setHasConsent(false);

    // Denegar todo en Google Consent Mode
    syncGtagConsent({ analytics: false, marketing: false });

    // Limpiar cookies existentes
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  };

  return {
    consent,
    hasConsent,
    mounted,
    updateConsent,
    revokeConsent,
    canUseAnalytics: consent?.analytics || false,
    canUseMarketing: consent?.marketing || false
  };
};

export default useCookieConsent;